import PropTypes from 'prop-types'
import React from 'react'
import {
  Content as ContentComponent
} from 'components/Content'
import classes from './Content.module.scss'

export class Content extends React.Component {
  static propTypes = {
    className: PropTypes.string
  }

  render () {
    let {
      children,

      className,

      ...restProps
    } = this.props

    let compClassName = classes.content
    if (className) compClassName += ' ' + className

    return (
      <ContentComponent
        {...restProps}
        className={compClassName}
      >
        {children}
      </ContentComponent>
    )
  }
}

export default Content
